import { Box, Typography } from '@material-ui/core';
import React from 'react'
import COLORS from '../../../styles/colors';

interface Props {
  totalReturn: number
  totalApproved: number | null
  totalPickup: number | null
}

const InfoProductSR: React.FC<Props> = (props) => {
  return (
    <Box display="flex" flexDirection="row">
      <Box width="25%" display="flex" flexDirection="row">
        <Typography color="textSecondary" style={{ marginRight: 20 }}>
          Total Retur
          </Typography>
        <Typography><b>{props.totalReturn}</b></Typography>
      </Box>
      <Box width="25%" display="flex" flexDirection="row">
        <Typography color="textSecondary" style={{ marginRight: 20 }}>
          Total Approved
          </Typography>
        <Typography
          style={!props.totalApproved
            ? { color: COLORS.grey, fontStyle: 'italic' }
            : { color: COLORS.primary }}
        >
          <b>{!props.totalApproved ? 'Not set' : props.totalApproved}</b>
        </Typography>
      </Box>
      <Box width="25%" display="flex" flexDirection="row">
        <Typography color="textSecondary" style={{ marginRight: 20 }}>
          Total Pickup
          </Typography>
        <Typography
          style={!props.totalPickup
            ? { color: COLORS.grey, fontStyle: 'italic' }
            : { color: COLORS.primary }}
        >
          <b>{!props.totalPickup ? 'Not set' : props.totalPickup}</b>
        </Typography>
      </Box>
    </Box>
  )
}

export default InfoProductSR